const fa = {
  9000001: "جایزه کریسمس 2023",
  9000002: "مسابقات فیوچرز سوپراکس",
  9000003: "30000 USDT در جایزه مسابقه برنده شوید!",
  9000004: "تعداد شرکت کنندگان",
  9000005: "استخر جایزه باز شد (USDT)",
  9000006: "واجد شرایط رتبه بندی حجم معاملات",
  9000007: " منرخ سودآوری رده‌بندی مسابقه",
  9000008: "رقابت مقدماتی رتبه بندی سود ",
  9000009: `رویداد  حجم معاملات: بالاترین جایزه <span style="color: #ffc72b;">20,000</span> USDT را باز کنید.`,
  9000010: "با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 20000 USDT بزرگتر باز می شود. ",
  9000011: "مقدار جایزه‌ها ",
  9000012: "به روز رسانی روزانه در ساعت 10:00 UTC.",
  9000013: "تخمین پاداش",
  9000014: "مبلغ معاملات آتی تجمعی در طول دوره",
  9000015: "قوانین پاداش",
  9000016: "با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 20000 USDT بزرگتر باز می شود. ",
  9000017: "مقدار جایزه‌ها (USDT)",
  9000018: "نرخ سودآوری فعالیت‌ها بر اساس رتبه‌بندی",
  9000019: "ثبت‌نام",
  9000020: "رتبه بندی سود فعالیت",
  9000021: "به پایان رسید",
  9000022: `مسابقه رتبه بندی نرخ سود - از پاداش <span style="color: #ffc72b;">{moneyPond}</span> USDT لذت ببرید`,
  9000023: `رقابت رتبه بندی سود - از پاداش <span style="color: #ffc72b;">{moneyPond}</span> USDT لذت ببرید`,
  9000024: "نرخ سودآوری کل فیوچر",
  9000025: "سود انباشته",
  9000026: "شروع نشده است",
  9000027: "به 50 شرکت کننده برتر در مسابقه رتبه بندی سود جوایزی اهدا خواهد شد. برای جزئیات، لطفاً برای دریافت جوایز به قوانین پاداش رتبه بندی مراجعه کنید. ",
  9000028: "به 50 شرکت کننده برتر از نظر سودآوری پاداش داده می شود، لطفاً برای دریافت پاداش به قوانین پاداش رتبه بندی معاملات مراجعه کنید. ",
  9000029: "رتبه بندی حجم تراکنش فعالیت",
  9000030: "ثبتنام موفقیتآمیز",
  9000031: "برنامه را دانلود کنید",
  9000032: "بازگشت به خانه",

  //合约交易积分
  9100001: "ذخیره امتیاز",
  9100002: "ایردراپ را دریافت کنید",
  9100003: "بازخرید جوایز",
  9100004: "موجودی امتیاز",
  9100005: "جزئیات",
  9100006: "امتیازهای ورود",
  9100007: "امتیاز معاملاتی",
  9100008: "امتیازهای دعوت",
  9100009: "امتیازهای پاداش",
  9100010: "قرعه کشی",
  9100011: "امتیاز بگیرید",
  9100012: "قوانین امتیازدهی",
  9100013: "جزئیات امتیازات",
  9100014: "برای شرکت در این رویداد باید ثبت نام کنید. برای ثبت نام کلیک کنید",
  9100015: "برای {day} روز متوالی معامله کرده اند و {num} امتیاز کسب کرده اند",
  9100016: "امروز {num} امتیاز کسب کرد",
  9100017: "استخر جایزه امتیاز",
  9100018: "هر قرعه کشی خوش شانس {point} امتیاز مصرف می کند و حداکثر {num} بار قرعه کشی در روز می تواند قرعه کشی شود.",
  9100019: "تعداد قرعه کشی های خوش شانس امروز",
  9100020: "کاربر",
  9100021: "امتیازها",
  9100022: "موجودی امتیاز کافی نیست",
  9100023: "موجودی امتیاز کافی نیست. لطفا قبل از شرکت در قرعه کشی امتیاز بگیرید.",
  9100024: "تعداد قرعه کشی های خوش شانس به حد خود رسیده است!",
  9100025: "تعداد قرعه کشی های خوش شانس امروز به حداکثر خود رسیده است. فردا دوباره امتحان کن.",
  9100026: "نحوه کسب امتیاز",
  9100027: "با مشارکت در فعالیت‌های جمع‌آوری امتیاز معامله قرارداد، امتیاز جمع کنید.",
  9100028: "ثبت نام موفق",
  9100029: "شما برای شرکت در فعالیت معاملات فیوچرز برای کسب امتیاز ثبت نام کرده اید. برای کسب امتیاز بیشتر بروید و تجارت کنید (دیگر از کمیسیون و پاداش های برگشت نقدی لذت نخواهید برد)",
  9100030: "پس از لغو ثبت نام، دیگر امتیازی دریافت نخواهید کرد. آیا مطمئن هستید که می خواهید ثبت نام خود را لغو کنید؟",
  9100031: "مرکز فعالیت امتیاز معاملاتی",
  9100032: "امتیاز بگیرید",
  9100033: "برای شرکت در این رویداد باید ثبت نام کنید. برای ثبت نام کلیک کنید",
  9100034: "شما می توانید با معاملات مداوم معاملات فیوچرز امتیاز کسب کنید",
  9100035: "کاربران می توانند برای تمام معاملات فیوچرز امتیاز کسب کنند",
  9100036: "جدول امتیازات",
  9100037: "پنج کاربر برتر در رتبه بندی معاملات روزانه امتیاز اضافی دریافت خواهند کرد",
  9100038: "کاربران دعوت شده امتیاز دریافت می کنند و دعوت کننده می تواند امتیاز جایزه دریافت کند.",
  9100039: '{guy} از قبل کسب کرده اید<span style="color:#D9A31A"> {num} امتیاز!</span>',
  9100040: "قرعه کشی خوش شانسی را امتحان کنید!",
  9100041: "تبریک بابت گرفتن",
  9100042: "همه انواع",
  9100043: "در این صفحه بمانید",
  9100044: "برای شرکت ثبت نام کنید",
  9100045: "معاملات را ادامه دهید",
  9100046: "در حال حاضر هیچ رویداد در حال انجام نیست. لطفا منتظر بروزرسانی‌ها باشید...",
  9100047: "را با توکن های SCS مبادله کنید",
  9100048: "",
  9100049: "",

  9100050: "تاریخ ها",
  9100051: "تاریخ شروع را انتخاب کنید",
  9100052: "تاریخ پایان",
  9100053: "به",
  9100054: "نوع",

  9100055: "امتیازات کسب شده = حجم معاملات * 1٪ (مشکل با افزایش حجم کل معاملات پلت فرم بیشتر تنظیم می شود)",
  9100056: "به عنوان مثال: کاربر از موقعیتی با حاشیه 100 USDT*100X=10000 USDT استفاده می کند.",
  9100057: "سپس برای دریافت 100 امتیاز فقط به یک واریز 100 USDT نیاز داری",
  9100058: "امتیاز معاملات تنها راه برای به دست آوردن توکن پلتفرم SCS است",
  9100059: "امتیاز پاداش اضافی = کل امتیازات برای روز * نسبت پاداش رتبه بندی",
  9100060: "رتبه بندی",
  9100061: "مقام اول",
  9100062: "مقام دوم",
  9100063: "مقام سوم",
  9100064: "مقام چهارم",
  9100065: "مقام پنجم",
  9100066: "کاربران دعوت شده امتیاز دریافت می کنند و دعوت کننده می تواند امتیاز جایزه دریافت کند.",
  9100067: "فاکتور سطح",
  9100068: "فرمول محاسبه: امتیاز ارجاع به دست آمده = امتیاز کسب شده توسط مدعو * ضریب سطح",
  9100069: "ضریب سطح با توجه به وضعیت واقعی تنظیم می شود",
  9100070: "به عنوان مثال: کاربر B در یک فعالیت امتیاز شرکت می کند و دعوت کننده آن کاربر A است و تعداد دعوت از کاربر A به سطح 3 رسیده است. کاربر B امتیاز جمع آوری کرده است = 360000;",
  9100071: "سپس امتیازهای تبلیغاتی تجمعی که کاربر A می تواند کسب کند = 360000 * 30% = 108000",
  9100072: "ضریب پاداش",
  9100073: "1 کاربران معاملاتی",
  9100074: "حجم معاملات به 5 میلیون رسید",
  9100075: "حجم معاملات به 20 میلیون رسید",

  9100076: "انتقال",

  //热币
  9100080: "به پایان رسید",
  9100081: "برای برنده شدن جوایز روی «اکنون بپیوندید» کلیک کنید",
  9100082: "مشاهده قوانین",
  9100083: "همین الان ملحق شوید، همین الان بپیوندید",
  9100084: "فعالیت",
  9100088: "تجارت",
  9100089: "سپرده",
  9100090: "شما قبلا ثبت نام کرده اید.",

  9100091: "این رویداد به پایان رسیده است، لطفا منتظر رویداد بعدی باشید!",
  9100092: "رویداد هنوز شروع نشده است، لطفاً منتظر بمانید.",
  9100093: "",
  9100094: "",

  //api key
  9100105: "کلید API ایجاد کنید",
  9100106: "مستندات API را مشاهده کنید",
  9100107: "سیستم معاملاتی یکپارچه",
  9100108: "کلید API ایجاد/مدیریت کنید",
  9100109: "API را گسترش دهید",
  9100110: "معاملات و درخواست‌ها",
  9100111: "پلتفرم پیشرو تجارت دارایی‌های دیجیتال",
  9100112: "طیف وسیعی از خدمات تجارت دارایی‌های دیجیتال و مدیریت دارایی‌ها را ارائه می‌دهد تا نیازهای تجاری متنوع را برآورده کند.",
  9100113: "خدمات بهتر ارائه می‌دهد",
  9100114: "کمیسیون‌های معاملاتی بهتر، مقادیر معامله بالاتر، قابلیت‌های مدیریت حساب انعطاف‌پذیرتر و غیره.",
  9100115: "انتخاب میلیون‌ها کاربر",
  9100116: "محیط معاملاتی امن را تضمین می‌کند، پشتیبانی مشتری حرفه‌ای را ارائه می‌دهد، به شما کمک می‌کند تا در دنیای دارایی‌های دیجیتال به طور پایدار پیشرفت کنید.",
  9100117: "چگونه در SuperEx کلید API ایجاد کنیم؟",
  9100118: "مستندات API SuperEx را کجا می‌توان مشاهده کرد؟",
  9100119: "چه کنیم اگر در معاملات SuperEx مشکلی پیدا کردیم؟",
  9100120: "چگونه API SuperEx را استفاده کنیم؟",
  9100121: "برای معاملات سریع‌تر و روان‌تر به API SuperEx دسترسی پیدا کنید",
  9100122: `وقتی وارد سیستم شده‌اید، مکان‌نما را بر روی آواتار - 'مدیریت API' قرار دهید و 'ایجاد کلید API' را کلیک کنید تا کلید API خود را در SuperEx ایجاد کنید. توجه: اگر وارد سیستم نشده‌اید، ابتدا باید وارد حساب کاربری SuperEx خود شوید.
همچنین می‌توانید کلید API خود را از پیوند 'APIs' در نوار ناوبری پایین ایجاد کنید.`,
  9100123: 'با کلیک بر <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">مستندات API</a> می‌توانید مستندات API SuperEx را مشاهده کنید.',
  9100124: "اگر در حین استفاده با مشکلی مواجه شدید یا پیشنهادی داشتید، می‌توانید از طریق مرکز کمک رسانی در وب‌سایت رسمی یا با ارسال ایمیل به <br>support@superex.com با ما تماس بگیرید.",
  9100125: `برای استفاده از API SuperEx، ابتدا باید:<br>
در حساب کاربری SuperEx خود ثبت‌نام کنید و وارد شوید.<br>
کلید API ایجاد کنید که برای شما access_key و secret_key تولید می‌کند.<br>
از این access_key و secret_key برای امضای درخواست‌های خود استفاده کنید.<br>
با توجه به نیازهای خود، می‌توانید از API‌های مختلفی که SuperEx ارائه می‌دهد، مانند API داده‌های بازار، API معاملات و API حساب‌ها استفاده کنید. مطمئن شوید که هر درخواست دستورالعمل‌های موجود در مستندات API را دنبال می‌کند و شامل سرصفحه‌های HTTP مناسب و امضاها می‌شود.`,
  9100126: "اقدام",
  9100127: "ایجاد کلید API جدید",
  9100128: "نام کلید API",
  9100129: "لطفاً نام کلید API را وارد کنید",
  9100130: "مجوزها (انتخاب چندگانه)",
  9100131: "خواندن",
  9100132: "معامله",
  9100133: "لیست سفید آدرس IP (اختیاری)",
  9100134: "شما می‌توانید تا 10 آدرس IP را به هر کلید API پیوند دهید، با کاما جدا شده‌اند. برای مثال:",
  9100135: "من خوانده ام و موافقم",
  9100136: "من خطرات کاربر API را خوانده و با آن موافقم",
  9100137: "ایجاد",
  9100138: 'SuperEx به شما یک API قدرتمند ارائه می‌دهد که به شما امکان استفاده از خدماتی مانند استعلام بازار و معامله خودکار را می‌دهد. نحوه استفاده را با مشاهده <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html/">مستندات API</a> ببینید.',
  9100139: "هر حساب می‌تواند تا 10 کلید API ایجاد کند.",
  9100140: `کلیدهای API که به IP متصل نیستند پس از 90 روز به طور خودکار منقضی می‌شوند. اگر قصد دارید از آن‌ها به مدت طولانی استفاده کنید، می‌توانید کلید API خود را تحت 'کلید API من' - 'اقدام' - 'تمدید'، تمدید کرده و دوره اعتبار آن را 90 روز دیگر تمدید کنید. کلیدهای API متصل به IP محدودیت انقضا ندارند.`,
  9100141: "کلید API من",
  9100142: "مجوزها",
  9100143: "آدرس IP",
  9100144: "تمدید",
  9100145: "ایجاد کلید API نیاز به واریز هر مقدار پول به کیف پول نقدی شما برای فعال سازی حساب شما دارد",
  9100146: "تمدید فعلی کلید API را تأیید کنید",
  9100147: "کلید دسترسی و کلید مخفی خود را فاش نکنید تا از ضرر دارایی جلوگیری کنید.",
  9100148: "به دلایل امنیتی، توصیه می‌شود که کلیدهای API به آدرس‌های IP خاصی متصل شوند. یک کلید API می‌تواند به حداکثر ۲۰ آدرس IP یا بخش‌های IP متصل شود. شما می‌توانید یک آدرس IP واحد یا چندین آدرس را مستقیماً وارد کنید و آدرس‌های مختلف را با کاما جدا کنید. به عنوان مثال: 192.168.1.1,192.168.1.2",
  9100149: "پس از تمدید موفق، تاریخ انقضا مجدداً محاسبه می‌شود. اگر قصد دارید از کلید API به طور طولانی مدت استفاده کنید، توصیه می‌شود آدرس IP را متصل کنید. کلیدهای API متصل به IP منقضی نمی‌شوند و همچنین ایمن‌تر هستند.",
  9100150: "حذف فعلی کلید API را تأیید کنید؟",
  9100151: "شما باید خطرات زیر را درک کنید:",
  9100152: "کلید API شما به شدت به امنیت حساب شما مرتبط است. هر کسی که کلید API شما را بداند ممکن است دارایی‌های حساب شما را کنترل کند. بنابراین، لطفاً آن را به درستی محافظت کنید، کلید API خود را به اشخاص ثالث فاش نکنید و آن را در وب‌سایت‌ها یا انجمن‌های ثالث بارگذاری نکنید.",
  9100153: "اگر کلید API شما به دلایل شخصی شما، از جمله اما نه محدود به مسائل امنیتی دارایی و ضررهای اقتصادی نشت کند، شما مسئولیت کامل ناشی از آن را بر عهده خواهید گرفت و ما هیچ مسئولیتی نخواهیم داشت.",
  9100154: "اطلاعیه خطر",
  9100155: "من آگاهم و حاضرم ریسک را بپذیرم.",
  9100156: "ذخیره شد",
  9100157: "مجوزها",
  9100158: "کلید مخفی تنها یک بار نمایش داده می‌شود و در صورت از دست رفتن قابل بازیابی نیست، لطفاً آن را به دقت نگه دارید.",
  9100159: "کلید دسترسی و کلید مخفی خود را فاش نکنید تا از ضرر دارایی جلوگیری کنید.",
  9100160: "اگر کلید مخفی خود را فراموش کرده‌اید، لطفاً این جفت کلید را حذف کرده و برای یک جفت جدید درخواست دهید.",
  9100161: "ما API قدرتمندی ارائه می‌دهیم تا به شما کمک کنیم تا ویژگی‌های معاملاتی را به طور مؤثر در برنامه‌های خود ادغام کنید. API‌ها به سه دسته حساب، معاملات و داده‌های بازار تقسیم شده‌اند، که به شما امکان می‌دهد مجوزهای لازم را پیکربندی کنید و معاملات خودکار را از طریق API پیاده‌سازی کنید.",
  9100162: "زمان لیست شدن",
  9100163: "ایجاد کلید API جدید",
  9100164: "ویرایش کنید",
  9100165: "تاریخ سررسید",
  9100166: "حذف",
  9100167: "با موفقیت ایجاد شد",
  9100168: "نکات",
  9100169: "باشه",
  9100170: "اعلان خطر کاربر API",
  9100171: "فرمت آدرس IP نادرست است",
  9100172: "",
  //自由区二维码分享页面
  91000951: "لیست در اسپات Meme، در حال حاضر با آزادی مالی راه اندازی میشود",
  91000961: "برنامه را باز کنید",
  //自由区二维码分享页面
  9100095: "لیست در اسپات Meme، در حال حاضر با آزادی مالی راه اندازی میشود",
  9100096: "برنامه را باز کنید",
  9100097: "",
  9100098: "",

  //代理商
  101738: "یک نماینده سوپراکس شوید و از کمیسیون های بالا لذت ببرید!",
  101739: "دوستان خود را به معامله با سوپراکس دعوت کنید و 50٪ از کمیسیون را دریافت کنید. پس از قراردادهای تجاری ارجاعات خود، شروع به دریافت کمیسیون کنید. مشاهده قوانین",
  101740: "تبدیل شدن به یک نماینده",
  101741: "چگونه می توانم کمیسیون بگیرم؟",
  101742: "برای نمایندگی شدن اقدام کنید",
  101743: "اگر جامعه، دنبال کننده رسانه و منابع دیگر دارید، می توانید برای نماینده شدن درخواست دهید و پس از یک برنامه موفق، می توانید به یک نماینده ارتقا دهید.",
  101744: "سوپراکس را تبلیغ کنید",
  101745: "لینک دعوت خود را با انجمن، دنبال کنندگان یا کانال های دیگر خود برای قرار گرفتن در معرض تبلیغات به اشتراک بگذارید",
  101746: "کمیسیون بگیرید",
  101747: "وقتی کاربران جدید از طریق پیوند دعوت خود ثبت نام کرده و تجارت می کنند، می توانید کمیسیون دریافت کنید.",
  101748: "چقدر می توانم کمیسیون کسب کنم؟",
  101749: "وقتی کاربران را به تجارت با سوپراکس دعوت می کنید، 20 درصد از کمیسیون دوست خود را به عنوان پاداش دعوت دریافت می کنید. اگر",
  101750: "یک نماینده سوپراکس شوید، 50٪ پاداش نماینده نیز دریافت خواهید کرد.",
  101751: "چرا یک کارگزار سوپراکس شوید؟",
  101752: "کمیسیون بالا",
  101753: "دریافت 50% کمیسیون",
  101754: "پشتیبانی از ترافیک کاربر",
  101755: "پشتیبانی حرفه ای از ترافیک، دسترسی آسان به درآمد",
  101756: "پشتیبانی از برندینگ",
  101757: "رویدادهای آفلاین جهانی با لوازم جانبی هدیه سفارشی",
  101758: "رویدادهای آفلاین جهانی",
  101759: "جلسه هواداران آفلاین جهانی سوپراکس، جلسات برتر صنعت، و پشتیبانی همه جانبه برای هر نماینده، برای کمک به افزایش درآمدشان!",
  101760: "بازبینی ناموفق بود",
  101761: "عوامل",
  101762: "مدیریت کانال",
  101763: "ایجاد کانال",
  101764: "کانال های وابسته",
  101765: "روش ترویج",
  101766: "نام کانال",
  101767: "ایجاد شده",
  101768: "ویرایش کنید",
  101769: "نسبت تخفیف فیوچرز",
  101770: "نسبت تخفیف نقطه ای",
  101771: "مدیریت ارتقاء",
  101772: "کد دعوت",
  101773: "کد دعوت",
  101774: "تعداد باقیمانده پیوندهای تبلیغاتی که باید ایجاد شوند",
  101775: "دوستان",
  101776: "کد دعوت نماینده",
  101777: "تعداد مراجعات نمایندگی",
  101778: "کدهای دعوت معمولی",
  101779: "تعداد مراجعات منظم",
  101780: "لینک دعوت",
  101781: "کانال های معمولی",
  101782: "تابلوی اطلاعات",
  101783: "سپرده ها",
  101784: "مقدار تراکنش",
  101785: "کمیسیون",
  101786: "کد دعوت",
  101787: "ارتباط دعوت با موبایل",
  101788: "گزارش های فیوچرز",
  101789: "گزارش های اسپات",
  101790: "معاملات",
  101791: "مرکز اسکان",
  101792: "تسویه قرارداد",
  101793: "تسویه نقطه ای",
  101794: "کمیسیون تخمینی",
  101795: "ثبت برداشت",
  101796: "مشاهده دارایی ها",
  101797: "مبلغ برداشت شده",
  101798: "کمیسیون انباشته شده",
  101799: "توکن های فعلی مبلغ برداشت را برآورده نمی کنند. می توانید برای دریافت پول پاداش، کاربران بیشتری را به معامله دعوت کنید.",
  101800: "بررسی اجمالی داده های قرارداد",
  101801: "بررسی اجمالی داده های نقطه ای",
  101802: "جزئیات قرارداد",
  101803: "جزئیات نقطه",
  101804: "تمام جهت",
  101805: "کمیسیون تخمینی نماینده",
  101806: "کمیسیون تخمینی کاربر",
  101807: "زمان معامله",
  101808: "برای قوانین دقیق، لطفاً اطلاعیه سوپراکس را بررسی کنید.",
  101809: "فرم درخواست برنامه نماینده سوپراکس",
  101810: "زبان شما",
  101811: "شما اهل کدام کشور هستید؟ (مثال: ایران)",
  101812: "پلتفرم/کانال اصلی شما چیست؟",
  101813: "در پلتفرم / رسانه های اجتماعی / وب سایت خود چند دنبال کننده / طرفدار / کاربر دارید؟",
  101814: "لینک/ادرس پلت فرم/کانال اصلی خود را پر کنید (URL کامل را وارد کنید)",
  101815: "سایر کانال های اجتماعی / پیوندهای وب سایت (URL کامل را وارد کنید)",
  101816: "اسم شما",
  101817: "برای تماس سریع با شما کانال های رسانه های اجتماعی را پر کنید (به عنوان مثال شناسه تلگرام @xxx)",
  101818: "از کجا با برنامه نماینده ما آشنا شدید؟",
  101819: "دوست",
  101820: "اطلاعات اضافی را می توانید با ما به اشتراک بگذارید، مانند درباره خودتان و معرفی مختصری از کانال خود",
  101821: "عالی!",
  101822: "شما برنامه نماینده سوپراکس را با موفقیت تکمیل کردید. پس از گذراندن بررسی، از طریق ایمیل به شما اطلاع خواهیم داد.",
  101823: "بازه زمانی نمی تواند بیش از 3 ماه باشد",
  101824: "موفق",
  101825: "همه برداشت ها",
  101826: "برداشته شد",
  101827: "توکن های فعلی مبلغ برداشت را برآورده نمی کنند. می توانید برای دریافت پول پاداش، کاربران بیشتری را به معامله دعوت کنید.",
  101828: "مدیریت کاربر",
  101829: "شناسه کاربر",
  101830: "نسبت کمیسیون فیوچرز",
  101831: "نسبت کمیسیون لحظه ای",
  101832: "زمان ثبت نام",
  101833: "جزئیات معامله",
  101834: "خرید لانگ",
  101835: "فروش شورت",
  101836: "فروش لانگ",
  101837: "خرید شورت",
  101838: "زمان برداشت",
  101839: "ارز برداشت",
  101840: "تعداد برداشت‌ها",
  101841: "کمیسیون",
  101842: "مبلغ قابل برداشت",
  101843: "برداشت از حساب",
  101844: "انجمن",
  101845: "ایمیل (این ایمیل برای دریافت اطلاعات نماینده استفاده خواهد شد، لطفاً اگر پیام تأییدی یافت نشد ایمیل اسپم خود را بررسی کنید)",
  101846: "کد تایید",
  101847: "در حال بررسی درخواست شما هستیم صبور باشید. زمانی که تایید شد با ایمیل به شما اطلاع خواهیم داد.",
  101848: "با عرض پوزش، درخواست نماینده شما تایید نشد",
  101849: "مجددا درخواست دهید",
  101850: "بررسی اجمالی داده ها",
  101851: "نرخ کمیسیون قرارداد نمایندگان",
  101852: "نرخ کمیسیون نقطه ای نمایندگان",
  101853: "شما به عنوان نماینده رد صلاحیت شده اید، اگر سوالی دارید لطفا با مدیر تماس بگیرید",
  101854: "همیشه",
  101855: "دیروز",
  101856: "این ماه",
  101857: "ماه گذشته",
  101858: "تعداد معامله گران",
  101859: "کل سپرده",
  101860: "کد دعوت را انتخاب کنید",
  101861: "درآمد ناخالص",
  101862: "کمیسیون معاملات فیوچرز",
  101863: "کمیسیون لحظه ای",
  101864: "انتظار",
  101865: "برداشته شد",
  101866: "برای آنلاک شدن",
  101867: "*برای استفاده، درآمد کمیسیون باید به حساب اسپات من برداشت شود.",
  101868: "تایید برداشت",
  101869: "آیا مطمئن هستید که می خواهید همه ارزها را به حساب اسپات من برداشت کنید؟",
  101870: "توکن های فعلی مبلغ برداشت را برآورده نمی کنند. می توانید برای دریافت پول پاداش، کاربران بیشتری را به معامله دعوت کنید.",
  101871: "قفل شده است",
  101872: "معکوس شد",
  101873: "صلاحیت نماینده لغو شد",
  101874: "قبلا یک نماینده",
  101875: "نمای کلی داده های کانال",
  101876: "داده های کاربر",
  101877: "به حساب فیوچرز کیف پول ابری",
  101878: "به حساب اسپات Wallet Cloud",
  101879: "جزئیات معاملات اسپات",
  101880: "جزئیات معاملات فیوچرز",
  101881: "مرکز تسویه معاملات فیوچرز",
  101882: "مرکز تسویه اسپات",
  101883: "گزارش اثربخشی",
  101884: "زبان را انتخاب کنید",
  101885: "پاسخ خود را وارد کنید",
  101886: "نام کانال را انتخاب کنید",
  101887: "برداشت کمیسیون",
  101888: "نام کانال را وارد کنید",
  101889: "روش تبلیغ را انتخاب کنید",
  101890: "یادداشت ها را وارد کنید",
  101891: "دارایی های موجود برای برداشت",
  101892: "برداشت را تایید کنید",
  101893: "نسبت کمیسیون فیوچرز کاربر را تنظیم کنید",
  101894: "نسبت کمیسیون اسپات کاربر را تنظیم کنید",
  101895: "گزارش عملکرد فیوچرز",
  101896: "گزارش عملکرد نقطه ای",
  101897: "تبدیل (USDT)",
  101898: "برداشت به کیف پول ابری",
  101899: "آیا مطمئن هستید که می خواهید تمام کمیسیون های اسپات خود را به کیف پول ابری خود برداشت کنید؟",
  101900: "مشاهده وجوه",
  101901: "همه ارزها",
  101902: "برداشته نشده است",
  101903: "کمیسیون کل",
  101904: "لطفاً یک کشور یا منطقه را انتخاب کنید",
  101905: "کد تایید را وارد کنید",
  101906: "سیستم نمایندگی",
  101907: "متشکرم.",
  101908: "درخواست شما ارسال شد. ما معمولاً اطلاعات شما را در عرض 2-3 روز کاری بررسی می کنیم و کمیسیون شما پس از گذراندن بررسی مؤثر خواهد بود!",

  //代理商拉新
  92000000: "شمارش معکوس رویداد",
  92000001: "روش‌های شرکت",
  92000002: "شما باید اطمینان حاصل کنید که حسابی که کار را انجام می‌دهد با حساب ثبت‌نام/ورود شما در صفحه فعلی مطابقت دارد تا شانس دریافت پاداش داشته باشید.",
  92000003: "انتظار تایید وظیفه",
  92000004: 'ثبت‌نام به دعوت <span style="color:#000922;font-weight:500;">{brokerName}</span> در SuperEx برای بازکردن پاداش خوش‌آمدگویی محدود!',
  92000005: "شروع از {time}",
  92000006: "تکمیل تا {time}",
  92000007: "تکمیل کار ممکن است تا 7 روز کاری طول بکشد، لطفاً شکیبا باشید.",
  92000008: "حدود 7 روز پس از پایان رویداد",
  92000009: "پس از تأیید صحت وظیفه، پاداش فعالیت ظرف 7 روز کاری پس از پایان فعالیت به حساب واریز می‌شود.",
  92000010: 'با استفاده از پیوند دعوت <span style="color:#000922;font-weight:400;">{brokerName}</span> ثبت نام کنید',
  92000011: "شرایط و ضوابط",
  92000012: "فعالیت در حال انجام",
  92000013: "امکان شرکت در این رویداد وجود ندارد",
  92000014: "رویداد به پایان رسید",
  92000015: "دریافت پاداش",
  92000016: "اکنون وارد شوید",
  92000017: "لطفاً یک نام کاربری تعیین کنید",

  92000018: "ملاحظات",
  92000019: "این آیتم پیشنهاد می شود",
  92000020: "ثبت",
  92000021: "اشتراک‌گذاری پوستر",
  92000022:'حداکثر',
  92000023:'ویرایش کانال',
  92000024:'ایجاد کانال وابسته',
  92000025:'در این کانال کد دعوت نیست',
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default fa;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/fa.js